import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        report: '=',
        comparisonReport: '=',
        questionCounter: '='
    },
    template: `
    <div class="items09">
        <div class="item"
            ng-repeat="question in vm.questions"
            ng-init="comparisonQuestion = vm.comparisonQuestions[$index]">
            <evaluation-public-report-question-scale
                ng-if="question.type==vm.QUESTIONS_TYPE_ENUM.KEYS.SCALE"
                question="question"
                counter="vm.questionCounter[question.id]"
                comparison-question="comparisonQuestion"
                title="vm.report.groupName"
                comparison-title="vm.comparisonReport.groupName"
            />
            <evaluation-public-report-question-text
                ng-if="question.type==vm.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT"
                question="question"
                counter="vm.questionCounter[question.id]"
                is-comparison="true"
            />
        </div>
    </div>
    `
})
export default class {
    constructor (lodash, EVALUATION_ROLE_ENUM, QUESTIONS_TYPE_ENUM) {
        this.lodash = lodash;
        this.EVALUATION_ROLE_ENUM = EVALUATION_ROLE_ENUM;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
    }

    $onInit () {
        this.questions = this.lodash.get(this.report, 'categoriesForm.questionsWithoutCategories', {});
        this.comparisonQuestions = this.lodash.get(
            this.comparisonReport,
            'categoriesForm.questionsWithoutCategories',
            {}
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/report/results/index.js